import React from 'react';
import I18n from 'i18n-js';
import { RCIcon, RCPopover } from '@reverbdotcom/cadence/components';
import { BellIcon } from '@reverbdotcom/cadence/icons/react';

export default function NotificationsCenterPopover() {
  return (
    <RCPopover
      position="bottom-end"
      anchor={(
        <button
          type="button"
          className="reverb-header__nav__link reverb-header__nav__link--notification-icon"
        >
          <div className="reverb-header__nav__link__icon">
            <RCIcon icon={<BellIcon />} />
          </div>
          <div className="reverb-header__nav__link__label">
            {I18n.t('discovery.reverbHeader.notifications')}
          </div>
        </button>
      )}
    >
      <div className="notifications-center__placeholder" />
    </RCPopover>
  );
}
